import { EventResult } from '../shared/types'
import { SortingOption } from '../screens/App/Events/EventResults/EventResults'

export interface CompleteMemberResult {
  memberId: string
  wonOffense: number
  lostOffense: number
  lostDefense: number
  round1: number
  round2: number
  completeResult: number
}

const getSortedResults = (eventResults: EventResult[], sortingOption: SortingOption) => {
  const items: CompleteMemberResult[] = []
  const memberObject: any = {}
  eventResults.map((element) => {
    if (element.results && Object.keys(element.results).length > 0) {
      Object.keys(element.results).map((memberId) => {
        if (!memberObject[memberId]) {
          memberObject[memberId] = {
            wonOffense: 0,
            lostOffense: 0,
            lostDefense: 0,
            offensePoints: 0,
            defensePoints: 0,
            completeResult: 0,
          }
        }
        memberObject[memberId] = {
          wonOffense: memberObject[memberId].wonOffense + element.results[memberId].wonOffense,
          lostOffense: memberObject[memberId].lostOffense + element.results[memberId].lostOffense,
          lostDefense: memberObject[memberId].lostDefense + element.results[memberId].lostDefense,
          // TODO offensePoints und defensePoints noch berechnen
          offensePoints: 0,
          defensePoints: 0,
          round2: memberObject[memberId].wonOffense,
          round1: element.results[memberId].wonOffense,
          completeResult: memberObject[memberId].completeResult + element.results[memberId].completeResult,
        }
      })
    }
  })
  Object.keys(memberObject).map(memberId => {
    items.push({ ...memberObject[memberId], memberId })
  })

  let sortedResult
  switch (sortingOption) {
    case SortingOption.complete:
      sortedResult = items.sort((a, b) => b.completeResult - a.completeResult)
      break
    case SortingOption.round1:
      sortedResult = items.sort((a, b) => b.round1 - a.round1)
      break
    case SortingOption.round2:
      sortedResult = items.sort((a, b) => b.round2 - a.round2)
      break
  }

  return sortedResult
}

export default getSortedResults
